import { useState } from "react";

import AddIcon from "@mui/icons-material/AddRounded";
import { Autocomplete, Box, Button, Stack, TextField } from "@mui/material";

import { TemplateItem, TemplateLabels } from "../TemplateManagement.types";

interface Props {
  templates: TemplateItem[];
  selectedTemplate: TemplateItem | null;
  labels: TemplateLabels;
  onSelect: (template: TemplateItem | null) => void;
  onAddNew: () => void;
}

export function TemplateSelect({ templates, selectedTemplate, labels, onSelect, onAddNew }: Props) {
  const selectedTitle = selectedTemplate?.title ?? "";
  const [inputValue, setInputValue] = useState(selectedTitle);
  const [syncedTemplate, setSyncedTemplate] = useState(selectedTemplate);
  if (syncedTemplate !== selectedTemplate) {
    setSyncedTemplate(selectedTemplate);
    setInputValue(selectedTitle);
  }

  return (
    <Stack direction="row" gap={2} alignItems="stretch" justifyContent="space-between">
      <Box flex="0 1 400px" minWidth={0}>
        <Autocomplete
          value={selectedTemplate}
          onChange={(_, newValue) => onSelect(newValue)}
          inputValue={inputValue}
          onInputChange={(_, newInputValue, reason) =>
            setInputValue(reason === "input" ? newInputValue : selectedTitle)
          }
          options={templates}
          size="small"
          getOptionLabel={(option) => option.title}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          fullWidth
          noOptionsText={labels.noTemplates}
          renderInput={(params) => <TextField {...params} label={labels.selectTemplate} />}
        />
      </Box>
      <Button
        variant="outlined"
        size="medium"
        startIcon={<AddIcon />}
        onClick={onAddNew}
        sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
      >
        {labels.addTemplate}
      </Button>
    </Stack>
  );
}
